export enum EventRecurrence {
    NotRepeating = "No se repite",
    Weekly = "Semanal",
}